import React, { Fragment, useContext, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import Collapse from "@material-ui/core/Collapse"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import { AppContext } from "Views/Home/context"
import Icon from "../Icon"
import cal from "clsx"
import { useSideListItemStyles } from "./style"
import { useSwitch } from "Hooks/basic"
import { Menu } from "Types/menu"

interface ComponentProps {
    menu: Menu,
}

const ListItemRightIcon = ({menu, open, classes, hasChild}: any) => {
    return (
        <Fragment>
            {menu.name}
            {hasChild && (
                <b className={cal(
                    classes.icon,
                    open && classes.open,
                )}/>
            )}
        </Fragment>
    )
}

const SideListItem = (props: ComponentProps) => {
    const classes = useSideListItemStyles()
    const { menu } = props
    const history = useHistory()
    const location = useLocation()
    const { open, toggle } = useSwitch(false)
    const { activeMenu, handleChangeActiveMenu } = useContext(AppContext)
    const { icon, id, url } = menu
    const { child_menus: children = [] } = menu
    const hasChild = children && children.length > 0
    const currentIsActive = activeMenu && activeMenu.id === id
    const handleClick = () => {
        // Todo 侧边菜单点击
        const isChildMenu = Boolean(url)
        if (isChildMenu) {
            handleChangeActiveMenu(menu)
            history.push(url)
        } else {
            toggle()
        }
    }
    const initialMenu = () => {
        // Todo 初始化侧边菜单栏选中状态
        // if (url === "/finance") {
        //     handleChangeActiveMenu(menu)
        // }
        if (location.pathname === url) {
            handleChangeActiveMenu(menu)
        }
    }
    useEffect(() => {
        initialMenu()
        // eslint-disable-next-line
    }, [])
    return (
        <Fragment>
            <ListItem button onClick={handleClick}>
                <div className={cal(
                    classes.sideItem,
                    currentIsActive && classes.active,
                )}>
                    <ListItemIcon>
                        <Icon icon={icon} />
                    </ListItemIcon>
                    <ListItemText primary={(
                        <ListItemRightIcon
                            menu={menu}
                            open={open}
                            classes={classes}
                            hasChild={hasChild}/>
                    )} />
                </div>
            </ListItem>
            {
                hasChild && (
                    <Collapse
                        in={open}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List component="div" disablePadding>
                            {children.sort((a: Menu, b:Menu) => {
                                return a.seq_num - b.seq_num
                            }).map((i) => <SideListItem {...props} key={i.id} menu={i}/>)}
                        </List>
                    </Collapse>
                )
            }
        </Fragment>
    )
}

export default SideListItem
